export const OfferFilterVariables = { filters: 'OfferFilters!' };
